import React from "react";
import OrgInvitations from "../../org/invitation/index";

const GroupInvitation = () => {
  return <OrgInvitations isGroupMode={true} />;
};

export default GroupInvitation;
